import type { FaireProductEntity } from "../../entity_types/product";

export const p_4bchw2apt5: FaireProductEntity = {
  token: "p_4bchw2apt5",
  type: "product",
  name: "Stars - Organic Cotton Jacquard Sweater Knit Baby Blanket",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/ed283a503efeca669e993f47e35c0a4fcd5a00da99900db009cdf5d0069736b1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/25747dcd45e0c69029a850a6ba3adc52abe09879ce20f1d40d059a3bd542a2be.jpeg",
    "https://cdn.faire.com/fastly/7ef31f42fed99a79b3b9b51fce12a86132746b138a9735958da0389af571a095.png",
    "https://cdn.faire.com/fastly/f18813c1df0a7f76baef962eef3c5dc299c3c8ecbef2024f1abcb784b0291a8e.jpeg",
    "https://cdn.faire.com/fastly/82a27057b54b7476bf7d9b492401f55fd53f73f1e4e39c8c7b983fe85dececf9.jpeg",
    "https://cdn.faire.com/fastly/883f30bfac623d30026bf113fbb9b0eda5d6b0357a5f29012fd69f283eb07506.jpeg",
    "https://cdn.faire.com/fastly/2f51f8ecc4383ee0629e88a76ae855d0f295da51bc3e5228cd65779a897f6a63.png",
    "https://cdn.faire.com/fastly/a5a5de2d7f0873e1158d8bdad7972e10dee132c14cc3ab901cb8951d62b77681.png",
  ],
  priceDollars: 26,
  description:
    "Crafted from 100% organic cotton, this knitted baby blanket features a timeless stars design and a generously sized, cozy feel—made for everyday comfort and calm.\n\n• Large size: 30 × 42 inches\n• Ultra-soft, lightweight, breathable, and comfortable for all seasons\n• Made from non-toxic, natural fibers, gentle on sensitive skin\n• Crafted using eco-friendly, sustainable materials\n• Made from sustainably grown organic cotton, supporting better livelihoods for small grower farmers\n• Thoughtfully designed in the USA and ethically made in India by skilled artisans\n\nCreated with care by Viverano, a family-owned small business dedicated to pure, honest comfort—because stars should feel as soothing as they look.",
  tags: [],
  msrpDollars: 52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:02:33.822Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
